(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var bar = document.getElementById('stox-announcement-bar');
  if (!bar || bar.dataset.hideOnScroll !== 'true') return;

  var lastY = 0;
  var ticking = false;

  window.addEventListener('scroll', function () {
    lastY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (lastY > 100) {
          bar.classList.add('stox-annbar--hidden');
        } else {
          bar.classList.remove('stox-annbar--hidden');
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Mobile drawer ────────────────────────────────────────────── */
  var root       = document.documentElement;
  var burger     = document.querySelector('.stox-burger');
  var mobileMenu = document.getElementById('stox-mobile-menu');
  var overlay    = document.getElementById('stox-overlay');
  var closeBtn   = document.getElementById('stox-menu-close');
  var lastFocus  = null;
  var overlayTimer = null;
  var lockedY = 0;

  // iOS Safari ignores overflow:hidden on body: pin the body instead, then restore the scroll position.
  function lockScroll() {
    lockedY = window.scrollY || window.pageYOffset || 0;
    var b = document.body.style;
    root.style.overflow = 'hidden';
    b.overflow = 'hidden';
    b.position = 'fixed';
    b.top = -lockedY + 'px';
    b.left = '0';
    b.right = '0';
    b.width = '100%';
  }

  function unlockScroll() {
    var b = document.body.style;
    root.style.overflow = '';
    b.overflow = b.position = b.top = b.left = b.right = b.width = '';
    window.scrollTo(0, lockedY);
  }

  function isMenuOpen() {
    return !!mobileMenu && mobileMenu.classList.contains('stox-mobile-menu--open');
  }

  function setAccordion(btn, open) {
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', String(open));
    if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  }

  function closeAccordions(except) {
    document.querySelectorAll('.stox-mobile-acc__btn[aria-expanded="true"]').forEach(function (b) {
      if (b !== except) setAccordion(b, false);
    });
  }

  function openMenu() {
    if (!mobileMenu || !overlay || !burger || isMenuOpen()) return;
    lastFocus = document.activeElement;
    clearTimeout(overlayTimer);
    overlay.style.display = 'block';
    mobileMenu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    lockScroll();
    requestAnimationFrame(function () {
      overlay.classList.add('stox-overlay--visible');
      mobileMenu.classList.add('stox-mobile-menu--open');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }

  function closeMenu() {
    if (!isMenuOpen()) return;
    mobileMenu.classList.remove('stox-mobile-menu--open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('stox-overlay--visible');
    burger.setAttribute('aria-expanded', 'false');
    unlockScroll();
    closeAccordions(null);
    overlayTimer = setTimeout(function () {
      if (!overlay.classList.contains('stox-overlay--visible')) overlay.style.display = 'none';
    }, 360);
    var back = lastFocus && document.contains(lastFocus) ? lastFocus : burger;
    if (back && back.focus) back.focus({ preventScroll: true });
  }

  if (burger) burger.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  if (overlay) {
    // Belt and braces for the scroll lock: the page never scrolls through the backdrop.
    ['wheel', 'touchmove'].forEach(function (type) {
      overlay.addEventListener(type, function (e) { e.preventDefault(); }, { passive: false });
    });
  }

  /* Keep Tab inside the open drawer */
  if (mobileMenu) {
    mobileMenu.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isMenuOpen()) return;
      var items = Array.prototype.filter.call(
        mobileMenu.querySelectorAll('a[href], button:not([disabled])'),
        function (el) { return el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden'; }
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ── Mobile accordéons — un seul ouvert à la fois ─────────────── */
  document.querySelectorAll('.stox-mobile-acc__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      closeAccordions(btn);
      setAccordion(btn, open);
    });
  });

  /* ── Desktop dropdowns — hover, click, keyboard ───────────────── */
  var activeMega = null;
  var megaSource = null;
  var quietFocus = false;
  var megaTimer  = null;

  function megaItem(id) {
    return document.querySelector('.stox-nav__item--has-mega[data-mega="' + id + '"]');
  }

  function setMega(id, open) {
    var item = megaItem(id);
    if (!item) return;
    var panel   = item.querySelector('.stox-mega');
    var trigger = item.querySelector('[data-mega-trigger]');
    if (panel)   panel.classList.toggle('stox-mega--open', open);
    if (trigger) trigger.setAttribute('aria-expanded', String(open));
  }

  function openMega(id, source) {
    cancelMegaClose();
    if (activeMega === id) return;
    closeMegaNow();
    activeMega = id;
    megaSource = source;
    setMega(id, true);
  }

  function closeMegaNow() {
    cancelMegaClose();
    if (!activeMega) return;
    setMega(activeMega, false);
    activeMega = null;
    megaSource = null;
  }

  function scheduleMegaClose() {
    cancelMegaClose();
    megaTimer = setTimeout(closeMegaNow, 150);
  }

  function cancelMegaClose() {
    if (megaTimer) clearTimeout(megaTimer);
    megaTimer = null;
  }

  document.querySelectorAll('.stox-nav__item--has-mega').forEach(function (item) {
    var id = item.getAttribute('data-mega');
    var trigger = item.querySelector('[data-mega-trigger]');

    item.addEventListener('mouseenter', function () { openMega(id, 'hover'); });
    item.addEventListener('mouseleave', function () { if (megaSource === 'hover') scheduleMegaClose(); });

    if (!trigger) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (activeMega !== id) { openMega(id, 'click'); return; }
      // Opened by the hover that preceded this click: keep it open, next click closes.
      if (megaSource === 'hover') { megaSource = 'click'; return; }
      closeMegaNow();
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        if (activeMega === id) closeMegaNow(); else openMega(id, 'key');
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        openMega(id, 'key');
        var first = item.querySelector('.stox-mega a');
        if (first) first.focus();
      }
    });

    // Keyboard focus opens the dropdown; leaving the item (trigger + panel) closes it.
    trigger.addEventListener('focus', function () {
      if (!quietFocus && trigger.matches(':focus-visible')) openMega(id, 'key');
    });
    item.addEventListener('focusout', function () {
      setTimeout(function () {
        if (activeMega === id && !item.contains(document.activeElement) && megaSource !== 'hover') closeMegaNow();
      }, 0);
    });
  });

  document.addEventListener('click', function (e) {
    if (!activeMega) return;
    if (!e.target.closest('.stox-nav__item--has-mega')) closeMegaNow();
  });

  /* ── Keyboard ─────────────────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (activeMega) {
      var item = megaItem(activeMega);
      var hadFocus = item && item.contains(document.activeElement);
      var trigger = item && item.querySelector('[data-mega-trigger]');
      closeMegaNow();
      if (hadFocus && trigger) { quietFocus = true; trigger.focus(); quietFocus = false; }
    }
    closeMenu();
    closeSearch();
  });
  /* ── Search overlay ───────────────────────────────────────────── */
  var searchOverlay  = document.getElementById('stox-search-overlay');
  var searchOpenBtn  = document.getElementById('stox-search-open');
  var searchCloseBtn = document.getElementById('stox-search-close');
  var searchInput    = document.getElementById('stox-search-input');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('stox-search-overlay--open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('stox-search-overlay--open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }

  if (searchOpenBtn) searchOpenBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
